import { IconButton } from "@mui/material";
import React from "react";
import {
  Sidebar,
  useProSidebar,
  MenuItem,
  Menu,
  SubMenu,
} from "react-pro-sidebar";

import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@emotion/react";
import { Link } from "react-router-dom";
import useHttpRequest from "../../hooks/useHttpRequest";
import { useEffect } from "react";
import { useState } from "react";
import { useContext } from "react";
import AuthContext from "../../context/Auth/AuthContext";
import FestivalIcon from "@mui/icons-material/Festival";
import StorefrontIcon from "@mui/icons-material/Storefront";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import MicIcon from "@mui/icons-material/Mic";
import AlbumIcon from '@mui/icons-material/Album';
import EventIcon from '@mui/icons-material/Event';
  

const DashboardSidebar = () => {
  const [halls, setHalls] = useState([]);
  const [isterahat, setIsterahat] = useState([]);
  const [photographers, setPhotographers] = useState([]);
  const [koshahs, setKoshahs] = useState([]);
  const [monshed, setMonshed] = useState([]);
  const [singers, setSingers] = useState([]);
  const [coiffures, setCoiffures] = useState([]);
  const [djs, setDjs] = useState([]);
  const [organizers, setOrganizers] = useState([]);
  const { collapsed, collapseSidebar } = useProSidebar();
  const { user, authState } = useContext(AuthContext);


  const theme = useTheme();
  const handleToggleSidebar = () => {
    collapseSidebar(!collapsed);
  };

  const {
    sendRequest: sendGetOwnedHallsRequest,
    status: getOwnedHallsRequestStatus,
    error: getOwnedHallsRequestError,
  } = useHttpRequest();

  const style = { backgroundColor: theme.palette.secondary.main };
 
  useEffect(() => {
    if (getOwnedHallsRequestStatus === "idle") {
      sendGetOwnedHallsRequest(
        { url: `api/subscripers/${user?.subscriper_uuid}/sidebar` },
        (data) => {
          setHalls(data.halls);
          setIsterahat(data.isterahat);
          setPhotographers(data.photographers);
          setMonshed(data.monshed);
          setSingers(data.singers);
          setCoiffures(data.coiffures);
          setKoshahs(data.koshahs);
          setDjs(data.djs);
          setOrganizers(data.organizers);
        }
      );
    }
  }, [
    getOwnedHallsRequestStatus,
    sendGetOwnedHallsRequest,
    user?.subscriper_uuid,
  ]);

  return (
    <Sidebar
      rootStyles={{ backgroundColor: "white" }}
      width="200px"
      rtl={true}
      false
    >
      <Menu>
        <MenuItem>
          <IconButton onClick={handleToggleSidebar}>
            <MenuIcon />
          </IconButton>
        </MenuItem>
        {halls && halls.length > 0 && (
          <SubMenu label="قاعات" icon={<FestivalIcon />}>
            {halls.map((item, index) => {
              const hallPath = `dashboard/halls/${item.uuid}`;
              return (
                <MenuItem key={index} component={<Link to={hallPath} />}>
                  {item.name}
                </MenuItem>
              );
            })}
          </SubMenu>
        )}

        {isterahat && isterahat.length > 0 && (
          <SubMenu label="استراحات" icon={<StorefrontIcon />}>
            {isterahat.map((item, index) => {
              return (
                <MenuItem
                  key={index}
                  component={<Link to={`dashboard/isterahat/${item.uuid}`} />}
                >
                  {item.name}
                </MenuItem>
              );
            })}
          </SubMenu>
        )}

        {photographers && photographers.length > 0 && (
          <SubMenu label="تصوير" icon={<CameraAltIcon />}>
            {photographers.map((item, index) => {
              return (
                <MenuItem
                  key={index}
                  component={<Link to={`dashboard/photographers/${item.uuid}`} />}
                >
                  {item.name}
                </MenuItem>
              );
            })}
          </SubMenu>
        )}

        {monshed && monshed.length > 0 && (
          <SubMenu label="إنشاد" icon={<MicIcon />}>
            {monshed.map((item, index) => {
              return (
                <MenuItem
                  key={index}
                  component={<Link to={`dashboard/monshed/${item.uuid}`} />}
                >
                  {item.name}
                </MenuItem>
              );
            })}
          </SubMenu>
        )}

        {singers && singers.length > 0 && (
          <SubMenu label="غناء" icon={<MusicNoteIcon />}>
            {singers.map((item, index) => {
              return (
                <MenuItem
                  key={index}
                  component={<Link to={`dashboard/singers/${item.uuid}`} />}
                >
                  {item.name}
                </MenuItem>
              );
            })}
          </SubMenu>
        )}

        {coiffures && coiffures.length > 0 && (
          <SubMenu label="كوافير" icon={<AlbumIcon />}>
            {coiffures.map((item, index) => {
              return (
                <MenuItem
                  key={index}
                  component={<Link to={`dashboard/coiffures/${item.uuid}`} />}
                >
                  {item.name}
                </MenuItem>
              );
            })}
          </SubMenu>
        )}

        {koshahs && koshahs.length > 0 && (
          <SubMenu label="كوشات" icon={<FestivalIcon />}>
            {koshahs.map((item, index) => {
              return (
                <MenuItem
                  key={index}
                  component={<Link to={`dashboard/koshahs/${item.uuid}`} />}
                >
                  {item.name}
                </MenuItem>
              );
            })}
          </SubMenu>
        )}

        {djs && djs.length > 0 && (
          <SubMenu label="دي جي" icon={<AlbumIcon />}>
            {djs.map((item, index) => {
              return (
                <MenuItem
                  key={index}
                  component={<Link to={`dashboard/djs/${item.uuid}`} />}
                >
                  {item.name}
                </MenuItem>
              );
            })}
          </SubMenu>
        )}

        {organizers && organizers.length > 0 && (
          <SubMenu label="تنسيق" icon={<EventIcon />}>
            {organizers.map((item, index) => {
              return (
                <MenuItem
                  key={index}
                  component={<Link to={`dashboard/organizers/${item.uuid}`} />}
                >
                  {item.name}
                </MenuItem>
              );
            })}
          </SubMenu>
        )}

      </Menu>
    </Sidebar>
  );
};

export default DashboardSidebar;
